import { AbstractFormatObjectsAlert } from "./AbstractFormatObjectsAlert";

export class FormatObjectsCountShortageAlert extends AbstractFormatObjectsAlert {
  constructor(private readonly _min: number, isError: boolean) {
    super("オブジェクト数不足", isError);
  }

  get description(): string {
    return "最低" + this._min + "個のオブジェクトが必要です。";
  }
}
